/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';

export const RadioDropdown = (props) => {
  const [radioValue, setRadioValue] = useState('');
  const [focusOnTextBox, setFocusOnTextBox] = useState(false);
  const [question] = useState(props);
  const options: any[] = [];
  question?.qstn?.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  question?.qstn?.options[1].values.forEach((val) => {
    options.push({ value: val.id, label: val.value });
  });

  return (
    <React.Fragment>
      <div key={question?.qstn?.questionId}>
        <RadioGroup
          label={<strong>{`${question.serial}. ${question.qstn?.questionText}`}</strong>}
          model={`qstn-${question?.qstn?.questionId}`}
          key={`type7-${question?.qstn?.questionId}-${question.serial}`}
          value={radioValue}
          validators={{ required: 'Please select an option' }}
          onChange={(e) => {
            if (focusOnTextBox === false) {
              return setRadioValue(e.target.value);
            }
          }}
        >
          <RadioGroup.Column>
          {question.qstn?.options.map((option, idx) => {
            return (
              <div
                style={{ paddingTop: '5px' }}
                // eslint-disable-next-line react/no-array-index-key
                key={`div-type7-${question?.qstn?.questionId}-${question.serial}-${idx}`}
              >
                {' '}
                {idx !== 1 ? (
                  <RadioGroup.Radio
                    label={option.values[0].value}
                    value={option.values[0].id}
                    key={`type-7-opt-${question.qstn.questionId}-${idx}`}
                  />
                ) : (
                  <div>
                    <RadioGroup.Radio label="Yes" value="Yes" key={option.id} />
                    {radioValue === 'Yes' ? (
                      <SelectInput
                        // label={question.qstn?.questionText}
                        placeholder="Please select"
                        model={`text-${question?.qstn?.questionId}`}
                        key={`type-7-opt-${question.qstn.questionId}-${idx}`}
                        isClearable
                        hideLabel
                        isSearchable
                        options={options}
                        onFocus={() => {
                          setFocusOnTextBox(true);
                        }}
                        onBlur={() => {
                          setFocusOnTextBox(false);
                        }}
                        validators={{
                          required: 'Please select an option from the dropdown',
                        }}
                      />
                    ) : null}
                  </div>
                )}
              </div>
            );
          })}
          </RadioGroup.Column>
        </RadioGroup>
      </div>
    </React.Fragment>
  );
};
